import React , { useState } from 'react';
import { Container } from "@mui/material";
import CustomInput from "../components/CustomInput/CustomInput";
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import {Link, useNavigate} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './RestorePassword.css';
import CustomModal from '../components/CustomModal/CustomModal';
import Email from "../../images/Email_send.png";
import {toast, ToastContainer} from "react-toastify";
import axios from "axios";
import LoadingButtonCustom from "../components/LoadingButton/LoadingButton";
import { URLS } from '../../context/urls'
import { RESTORE_PASSWORD_TEXTS } from './restorePasswordTexts';


function RestorePassword() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [cargando, setCargando] = useState(false)

    const navigate = useNavigate(); // Hook para obtener la función de navegación

    const handleClick = () => {
        navigate('/inicio-sesion');
    };

    const handleSendEmail = async (event) => {
        if (!email){
            toast.error(RESTORE_PASSWORD_TEXTS.TOAST_MESSAGES.EMAIL_REQUIRED, {
                position: 'top-center',
                autoClose: 2500,
                style: {
                    fontFamily: 'Viga',
                    fontSize:'12px',
                    top:'10px',
                    width: '300px', left: '9vw',
                },
            });
            return;
        }

        setCargando(true);
        try {
            const response = await axios.post(URLS.API_PASSWORD_RESET, { email }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                setIsModalOpen(true);
                console.log(response.data.message);
            } else if (response.status === 404) {
                

                toast.error(RESTORE_PASSWORD_TEXTS.TOAST_MESSAGES.NOT_REGISTERED, {
                    position: 'top-center',
                    autoClose: 2500,
                    style: {
                        fontFamily: 'Viga',
                        fontSize:'12px',
                        top:'10px',
                        width: '300px', left: '9vw',
                    },
                });
            } else {

                toast.error(RESTORE_PASSWORD_TEXTS.TOAST_MESSAGES.EMAIL_NOT_SENT, {
                    position: 'top-center',
                    autoClose: 2500,
                    style: {
                        fontFamily: 'Viga',
                        fontSize:'12px',
                        top:'10px',
                        width: '300px', left: '9vw',
                    },
                });
            }
        } catch (error) {

            toast.error(RESTORE_PASSWORD_TEXTS.TOAST_MESSAGES.EMAIL_NOT_SENT, {
                position: 'top-center',
                autoClose: 2500,
                style: {
                    fontFamily: 'Viga',
                    fontSize:'12px',
                    top:'10px',
                    width: '300px', left: '9vw',
                },
            });

            if (error.response) {
                //console.error(error.response.data.error);
            } else if (error.request) {
                //console.error("No se recibió respuesta del servidor");
            } else {
                //console.error("Error:", error.message);
            }
        } finally {
            setCargando(false);
        }
    };

    return (
        <>
            <Container maxWidth="xl">
                <ToastContainer position="top-center"/>
                <h1 className="title-restore-password">{RESTORE_PASSWORD_TEXTS.MAIN_TITLE}</h1>
                <div className='text-restore-password'>
                    <span>Ingresa tu correo electrónico o teléfono y te enviaremos</span>
                    <span>un enlace para que recuperes el acceso a tu Wuuju-cuenta.</span>
                </div>
                <CustomInput
                    additionalClassName="input-restore-password"
                    placeholder="Correo electrónico o teléfono"
                    type="text"
                    startIcon={<PermIdentityOutlinedIcon />}
                    hideValidation={true}
                    setValue={setEmail}
                />

                <LoadingButtonCustom
                    loading={cargando}
                    handleSubmit={handleSendEmail}
                    label="Enviar enlace de recuperación"
                    customStyles={{
                        fontSize: {xs: "3vw", sm: "1.2vw"},
                        marginTop: {xs: "4vw", sm: "1.2vw"}, 
                        marginBottom: {xs: "4vw", sm: "1.2vw"}, }}
                ></LoadingButtonCustom>

                <div className="linea-conjunto">
                    <div className="line"></div>
                    <div className="letter">{RESTORE_PASSWORD_TEXTS.OR_TEXT}</div>
                    <div className="line"></div>
                </div>

                <div>
                    <span className="restore-password-undertext">
                        <a className="" href="/crear-casillero">{RESTORE_PASSWORD_TEXTS.CREATE_ACCOUNT_TEXT}</a>
                    </span>
                </div>

                <div className='container-button-restore'>
                    <Link to="/inicio-sesion">
                        <button className='button-login-restore'>
                            <FontAwesomeIcon className='icon-button-restore' icon={faChevronLeft}/>
                            {RESTORE_PASSWORD_TEXTS.BACK_TO_LOGIN_TEXT}
                        </button>
                    </Link>
                </div>

                {/**MODAL CORREO ENVIADO */}
                <CustomModal
                    invertOrder={true}
                    onButtonClick={handleClick}
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    image={Email}
                    title={
                        <>
                           {RESTORE_PASSWORD_TEXTS.MODAL_TITLE}

                        </>
                    }
                    content={
                        <div>
                            <p>
                                Si la dirección de correo electrónico que proporcionaste está <br></br> asociada a una Wuuju-cuenta, recibirás un mensaje con un<br></br> <span className="purple-text">enlace para recuperar el acceso de tu cuenta</span>
                            </p>
                        </div>
                    }
                    buttonText={
                        <>
                           {RESTORE_PASSWORD_TEXTS.MODAL_BUTTON_TEXT}
                        </>
                    }
                    sx={{
                        title: {
                            color: '#5452e1',
                            fontSize: {xs:'5vw', sm:'2vw'},
                            fontFamily: "'Viga', sans-serif",
                            textAlign: 'center',
                            lineHeight: '1',
                            marginTop: '1.5vw'
                        },
                        content: {
                            color: 'gray',
                            fontSize: {xs:'3.5vw', sm: '1vw'},
                            textAlign: 'center',
                            position: 'relative',
                            overflow: 'hidden'
                        },
                        button: {
                            backgroundColor: '#b3df53',
                            color: 'white',
                            boxShadow:"0 3px 6px rgba(0, 0, 0, 0.1)",
                            textTransform:"none",
                            padding: "1vw",
                            fontSize: {xs: '3vw', sm: '1.4vw'},
                            borderRadius: '2vw',
                            transition: 'background-color 0.3s, transform 0.3s ease',
                            fontFamily: "'Viga', sans-serif",
                            marginBottom: '1vw',
                            display: 'flex',
                            '&:hover': {
                                backgroundColor: '#b3df53',
                                transform: 'scale(1.05)',
                            },
                        },
                        image: {
                            marginTop:"2vw",
                            width:"20vw"

                        },

                    }}
                />


            </Container>
        </>
    );
}

export default RestorePassword;